<template>
  <caption-text class="inactive-text"> ©{{ year }} {{ logoLabel }}. {{ $t("humanoo.rights") }}</caption-text>
</template>

<script>
import CaptionText from "@/components/ui-kit/typography/CaptionText";
import dayjs from "dayjs";

export default {
  name: "Copyright",
  components: { CaptionText },
  data() {
    return {
      year: dayjs().format("YYYY"),
      logoLabel: process.env.VUE_APP_LOGO_LABEL || ""
    };
  }
};
</script>

<style scoped></style>
